import React from "react";
import { PageHero, PageBody } from "./_shared";
import { usePoly } from "./PolyLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function ExecutiveBodyPage() {
  const data = usePoly();
  const list = data.executive_body || [];
  return (
    <div data-testid="poly-eb-page-wrap">
      <PageHero eyebrow="About" title="Executive Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="amber" testidPrefix="poly-eb-page" />
      </PageBody>
    </div>
  );
}
